import React, {useRef} from 'react';
import logo from 'mnsu-webapp-core/images/mnsu-logo.png'


const PageHeader = (props) => {
    let headerRef = useRef(null);

    return(
        <header id="header" className={"l-header header slide-over-transition l-header header slide-over-transition headroom headroom--not-bottom headroom--pinned headroom--top"} ref={headerRef}>
                <div className="l-header__elements">
                    <a className="l-logo" href="https://mankato.mnsu.edu"><img src={logo} className="main-logo" alt="Minnesota State University, Mankato logo" /></a>
                    <a className="l-mobile-logo" href="https://mankato.mnsu.edu"><img src={logo} className="main-logo" alt="Minnesota State University, Mankato logo" /></a>                                           
                </div>
            </header>
    );
};


export default PageHeader;